export default "__VITE_ASSET__DssobWjN__"